import { render, staticRenderFns } from "./Tradecount.vue?vue&type=template&id=594b2690&"
import script from "./Tradecount.vue?vue&type=script&lang=js&"
export * from "./Tradecount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports